import { render, staticRenderFns } from "./ediScfiPromptDialog.vue?vue&type=template&id=5bbe0fa2&scoped=true&"
import script from "./ediScfiPromptDialog.vue?vue&type=script&lang=js&"
export * from "./ediScfiPromptDialog.vue?vue&type=script&lang=js&"
import style0 from "./ediScfiPromptDialog.vue?vue&type=style&index=0&id=5bbe0fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbe0fa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bbe0fa2')) {
      api.createRecord('5bbe0fa2', component.options)
    } else {
      api.reload('5bbe0fa2', component.options)
    }
    module.hot.accept("./ediScfiPromptDialog.vue?vue&type=template&id=5bbe0fa2&scoped=true&", function () {
      api.rerender('5bbe0fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/edi/ediScfiPromptDialog.vue"
export default component.exports